import { createSlice } from "@reduxjs/toolkit"
import {
  addLoyaltyPoints,
  deleteCustomer,
  getAllCustomers,
  getAllCustomersList,
  getAppVersions,
  getBlackListCustomers,
  getCustomerDetails,
  getCustomerLoyaltyPoints,
  getPaymentHistory,
  getWalletHistory,
  restoreCustomer,
  revokeLoyaltyPoints,
  updateCustomer,
  updateCustomerStatus,
} from "store/actions/customersAction"

const initialState = {
  loading: true,
  error: null,
  isLoading: false,
  actionType: null,
  message: null,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  itemsPerPage: 50,
  isUpdating: false,
  customersList: [],
  customersDropdownList: [],
  blackListCustomers: [],
  customerDetails: {},
  customerLoyaltyPoints: [],
  loyaltyLoading: null,
  paymentHistory: [],
  paymentHistoryLoading: false,
  paymentCurrentPage: null,
  paymentTotalPages: null,
  paymentTotalCount: null,
  paymentHistory: [],
  walletHistoryLoading: false,
  walletCurrentPage: null,
  walletTotalPages: null,
  walletTotalCount: null,
  appVersions: [],
}

const usersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload || {}
    },
  },
  extraReducers: builder => {
    // FETCH  ALL CUSTOMERS
    builder
      .addCase(getAllCustomers.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload || {}
          state.customersList = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllCustomers.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getAllCustomersList.pending, state => {})
      .addCase(getAllCustomersList.fulfilled, (state, action) => {
        const { status, data } = action.payload || {}
        if (status) {
          state.customersDropdownList = data
        }
      })
      .addCase(getAllCustomersList.rejected, (state, action) => {})
    // FETCH BLACKLIST
    builder
      .addCase(getBlackListCustomers.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
      })
      .addCase(getBlackListCustomers.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload || {}
          state.blackListCustomers = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getBlackListCustomers.rejected, (state, action) => {
        state.loading = false
      })
    // UPDATE CUSTOMERS STATUS
    builder
      .addCase(updateCustomerStatus.pending, state => {
        state.error = null
        state.actionType = null
        state.isUpdating = true
      })
      .addCase(updateCustomerStatus.fulfilled, (state, action) => {
        const { status, data } = action.payload || {}
        if (status) {
          const { id, status: newStatus } = action.meta.arg // Renamed to newStatus to avoid confusion.
          // Update the customer status in customerDetails object
          state.customerDetails = {
            ...state.customerDetails,
            status: Number(newStatus),
          }
          state.isUpdating = false
          // state.customersList = state.customersList.map(customer =>
          //   customer._id === id
          //     ? { ...customer, status: Number(newStatus) }
          //     : customer
          // )
          state.message = action.payload.msg
          state.actionType = "CUSTOMER_UPDATED_SUCCESS"
        }
      })
      .addCase(updateCustomerStatus.rejected, (state, action) => {
        state.isUpdating = false
      })
    //   GET CUSTOMER DETAILS
    builder
      .addCase(getCustomerDetails.pending, state => {
        state.error = null
        state.actionType = null
        state.loading = true
      })
      .addCase(getCustomerDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.customerDetails = data
        }
      })
      .addCase(getCustomerDetails.rejected, (state, action) => {
        state.loading = false
        state.rolesList = []
      })

    // DELETE CUSTOMER
    builder
      .addCase(deleteCustomer.pending, state => {
        state.error = null
        state.isLoading = true
      })
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        const { status } = action.payload || {}
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.customersList = state.customersList.filter(
            item => item._id !== id
          )
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteCustomer.rejected, (state, action) => {
        state.isLoading = false
      })
    // RESTORE CUSTOMER
    builder
      .addCase(restoreCustomer.pending, state => {
        state.error = null
        state.isLoading = true
      })
      .addCase(restoreCustomer.fulfilled, (state, action) => {
        const { status } = action.payload || {}
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.customersList = state.customersList.filter(
            item => item._id !== id
          )
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(restoreCustomer.rejected, (state, action) => {
        state.isLoading = false
      })
    // UPDATE CUSTOMER
    builder
      .addCase(updateCustomer.pending, state => {
        state.error = null
        state.isLoading = true
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.isLoading = false
      })

    // FETCH  ALL CUSTOMERS LOYALTY POINTS
    builder
      .addCase(getCustomerLoyaltyPoints.pending, state => {
        // state.loading = true
        state.loyaltyLoading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getCustomerLoyaltyPoints.fulfilled, (state, action) => {
        // state.loading = false
        state.loyaltyLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload || {}
          state.customerLoyaltyPoints = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getCustomerLoyaltyPoints.rejected, (state, action) => {
        state.loading = false
      })

    // ADD LOYALTY POINTS
    builder
      .addCase(addLoyaltyPoints.pending, state => {
        state.isLoading = true
      })
      .addCase(addLoyaltyPoints.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addLoyaltyPoints.rejected, (state, action) => {
        state.isLoading = false
      })

    // REVOKE LOYALTY POINTS
    builder
      .addCase(revokeLoyaltyPoints.pending, state => {
        state.isLoading = true
      })
      .addCase(revokeLoyaltyPoints.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(revokeLoyaltyPoints.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET ALL PAYMENT HISTORY
    builder
      .addCase(getPaymentHistory.pending, state => {
        state.paymentHistoryLoading = true
        state.paymentCurrentPage = null
        state.paymentTotalPages = null
        state.paymentTotalCount = null
      })
      .addCase(getPaymentHistory.fulfilled, (state, action) => {
        state.paymentHistoryLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload || {}
          state.paymentHistory = data
          state.paymentTotalCount = totalCount
          state.paymentTotalPages = totalPages
          state.paymentCurrentPage = currentPage
        }
      })
      .addCase(getPaymentHistory.rejected, (state, action) => {
        state.paymentHistoryLoading = false
      })

    // GET ALL WALLET HISTORY
    builder
      .addCase(getWalletHistory.pending, state => {
        state.walletHistoryLoading = true
        state.walletCurrentPage = null
        state.walletTotalPages = null
        state.walletTotalCount = null
      })
      .addCase(getWalletHistory.fulfilled, (state, action) => {
        state.walletHistoryLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload || {}
          state.walletHistory = data
          state.walletTotalCount = totalCount
          state.walletTotalPages = totalPages
          state.walletCurrentPage = currentPage
        }
      })
      .addCase(getWalletHistory.rejected, (state, action) => {
        state.walletHistoryLoading = false
      })

    // GET ALL WALLET HISTORY
    builder
      .addCase(getAppVersions.pending, state => {})
      .addCase(getAppVersions.fulfilled, (state, action) => {
        const { status, data } = action.payload || {}
        if (status) {
          state.appVersions = data
        }
      })
      .addCase(getAppVersions.rejected, (state, action) => {})
  },
})

export const { setItemsPerPage } = usersSlice.actions

export default usersSlice.reducer
